<template>
  <div class="wind-legend">
    <div class="gradient-bar">
      <div
        v-for="(color, index) in colorStops"
        :key="index"
        class="color-segment"
        :style="{ backgroundColor: color }"
      />
    </div>
    <div class="labels">
      <ys-text
        v-for="(label, index) in labels"
        :key="index"
        class="label"
        size="small"
        type="metadata1"
      >
        {{ label }}
      </ys-text>
    </div>
  </div>
</template>
<script setup lang="ts">
///// imports /////
import { warn } from '@/lib/logger'
import '@onxmaps/yellowstone-ui/ys-text'

///// types /////
interface Props {
  labels: string[]
  colorStops: string[]
}

///// props/emits /////
const props = defineProps<Props>()

if (props.labels.length !== props.colorStops.length) {
  warn(
    'Logger',
    `[Legend] labels (${props.labels.length}) and colorStops (${props.colorStops.length}) should have the same length`
  )
}
</script>
<style scoped>
.wind-legend {
  margin-top: 6px;
}

.gradient-bar {
  display: flex;
  height: 8px;
  overflow: hidden;
}

.color-segment {
  flex: 1;
}

.labels {
  display: flex;
  padding-top: var(--ys-spacing-25);
}

.label {
  flex: 1;
}
</style>
